// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
            .icon-show {
                display: flex;
                gap: 10px;
                padding-top: 7px;
            }
            collab-comp-img-generator {
                color: #3d3db8;
                cursor: pointer;
            }
        `, "",{"version":3,"sources":["webpack://./src/app/shared/components/connector-action-button-renderer.component.ts"],"names":[],"mappings":";YACY;gBACI,aAAa;gBACb,SAAS;gBACT,gBAAgB;YACpB;YACA;gBACI,cAAc;gBACd,eAAe;YACnB","sourcesContent":["\n            .icon-show {\n                display: flex;\n                gap: 10px;\n                padding-top: 7px;\n            }\n            collab-comp-img-generator {\n                color: #3d3db8;\n                cursor: pointer;\n            }\n        "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
